module.exports = __webpack_public_path__ + "img/strong.0ba803fc.gif";